import { render, staticRenderFns } from "./UserFilters.vue?vue&type=template&id=2ef6705e&scoped=true"
import script from "./UserFilters.ts?vue&type=script&lang=ts&external"
export * from "./UserFilters.ts?vue&type=script&lang=ts&external"
import style0 from "./UserFilters.vue?vue&type=style&index=0&id=2ef6705e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef6705e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ef6705e')) {
      api.createRecord('2ef6705e', component.options)
    } else {
      api.reload('2ef6705e', component.options)
    }
    module.hot.accept("./UserFilters.vue?vue&type=template&id=2ef6705e&scoped=true", function () {
      api.rerender('2ef6705e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/UsersManager/components/UserFilters/UserFilters.vue"
export default component.exports